import React, {FC} from 'react'
import {Form, FormLabelProps, FormSelectProps, Stack} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {FaSearch} from 'react-icons/fa'
import {TOption} from '../constants/TOption'

interface SelectionProps {
  label?: string
  placeholder?: string
  data: TOption[]
  value: string
  onChange: (value: string) => void
  formLabelProps?: FormLabelProps
  formSelectProps?: FormSelectProps
  disabled?: boolean
  icon?: React.ReactNode
  hidden?: boolean
}

export const Selection: FC<SelectionProps> = (props) => {
  const {t} = useTranslation()
  const formControlRef = React.useRef<HTMLSelectElement>(null)

  React.useEffect(() => {
    const input = formControlRef.current
    if (input) {
      input.addEventListener('focus', () => {
        input.style.width = '140px'
      })
      input.addEventListener('blur', () => {
        input.style.width = '100%'
      })
    }
  }, [])

  return (
    <>
      {props.label && (
        <Form.Label {...props.formLabelProps} hidden={props.hidden}>
          {props.label}
        </Form.Label>
      )}

      <Stack
        direction='horizontal'
        hidden={props.hidden}
        gap={3}
        style={{
          border: '1.8px solid #d9dce4',
          background: 'white',
          borderRadius: 6,
          paddingLeft: 10,
        }}
      >
        <div style={{width: 'auto'}}>{props.icon}</div>

        <Form.Select
          ref={formControlRef}
          aria-label='Default select example'
          id='searchstatus'
          size='sm'
          hidden={props.hidden}
          placeholder={props.placeholder}
          disabled={props.disabled}
          onChange={(e: any) => props.onChange(e.target.value)}
          style={{
            border: 0,
            minHeight: 0,
            padding: '6.5px 0px',
            backgroundColor: 'transparent',
            color: '#5E6278',
            transition: '300ms width ease-in-out',
          }}
          {...props.formSelectProps}
        >
          <option value=''>
            {t('pilih')} {props.label}
          </option>

          {props.data.map((item) => (
            <option key={item.value} selected={props.value == item.value} value={item.value}>
              {t(item.label)}
            </option>
          ))}
        </Form.Select>
      </Stack>
    </>
  )
}

Selection.defaultProps = {
  icon: <FaSearch size={12} color='gray' style={{padding: 0}} />,
}
